import brandSymbol from "../assets/brand/logo-symbol.png";
// Static content + shared assets for the public website.
const IMG = "https://static.prod-images.emergentagent.com/jobs/84dd7a8e-5d50-45a2-83ef-8b8a9bdc3aac/images";

export const ILLUS = {
  focus_religious: `${IMG}/8b75c5ab175d17a033f41d0e8d59db55f951054c131813c5ac5994d9fbf714d1.jpeg`,
  focus_spiritual: `${IMG}/4a1b07737568adeaad3fbe112afa640950f4715968913ada1d1eb7ef30039ec0.jpeg`,
  focus_education: `${IMG}/da2136393aa4a03f22bd63eac742302296fd7fdfd8a9b8fa674da70802e60196.jpeg`,
  focus_children: `${IMG}/b14c78f46b55aed9300156eb8f4cbfd1bc50fc8946f84423693e92ac294119ea.jpeg`,
  focus_senior: `${IMG}/2839a349a72d0c44da291e487b07687a701cf9556eaa3f2f73a28afbc38f79b3.jpeg`,
  focus_eldercare: `${IMG}/cabb1182debb036f7fe17dbce8c33ba5bbea951beb40391e2a37e3514dad95eb.jpeg`,
  focus_health: `${IMG}/2b2a36907a93dbcbba46736704a7d633d48f27fe59c909d2277b4119a09a9321.jpeg`,
  focus_food: `${IMG}/4110107b8ebb783bffe1cac616a5a648e296fae863cdccd07f7b6fdfd675680d.jpeg`,
  focus_community: `${IMG}/c8bc6f771124f110575bc33658bcac8c85a4b61f6af8d841588fb0e5bb7c836a.jpeg`,
};

export const LOGO = brandSymbol;

export const PHOTOS = {
  heroTemple: "https://images.unsplash.com/photo-1566915682737-3e97a7eed93b?auto=format&fit=crop&w=1400&q=80",
  service: "https://images.unsplash.com/photo-1677128912094-36d988ce198b?auto=format&fit=crop&w=1200&q=80",
  lotus: "https://images.unsplash.com/photo-1593047833652-2ae65f74b22f?auto=format&fit=crop&w=1000&q=80",
  hands: "https://images.unsplash.com/photo-1651372381086-9861c9c81db5?auto=format&fit=crop&w=1200&q=80",
  templeHeritage: "https://images.unsplash.com/photo-1554554497-0095c34db3ec?auto=format&fit=crop&w=1200&q=80",
};

export const illustrationFor = (key) => ILLUS[key] || ILLUS.focus_community;

export const TRUST = {
  name: "Sri Akilandeswari Amman Trust",
  tagline: "A Legacy of Service. A Future of Hope.",
  email: "info@sriakilandeswariammantrust.org",
  established: "1995",
  regNumber: "424/95",
  regAct: "The Indian Trusts Act, 1882",
  regAuthority: "Sub-Registrar",
  regDate: "30-08-1995",
  regCity: "Tiruchirappalli",
  state: "Tamil Nadu",
  orgType: "Trust (Non-Government)",
  darpanId: "TN/2025/0706525",
  darpanDate: "04-07-2025",
  addressLines: [
    "No. 5-1/22,",
    "Ellai Mariyamman Kovil Street,",
    "Tiruchirappalli Fort,",
    "Tiruchirappalli – 620008,",
    "Tamil Nadu, India",
  ],
};

export const HERO_HEADLINE = "Serving Humanity. Inspiring Hope. Creating a Better Future.";
export const HERO_SUPPORTING =
  "Sri Akilandeswari Amman Trust is rooted in faith, service and community responsibility, with a commitment to meaningful religious, cultural and social-welfare initiatives.";

export const ABOUT_PARAGRAPHS = [
  "Sri Akilandeswari Amman Trust was established in 1995 with a commitment to serving society through compassion, community responsibility and meaningful social initiatives.",
  "Registered under the Indian Trusts Act, 1882, the Trust has its roots in Tiruchirappalli, Tamil Nadu, and seeks to contribute to the wellbeing of individuals, families and communities.",
  "The Trust's primary area of focus is religious and spiritual service connected with temples, together with cultural values and socially beneficial initiatives. Its broader areas of focus include children, education and literacy, support for senior citizens and elder care, old age home-related initiatives, food-related welfare initiatives, health and family welfare, and community wellbeing.",
  "Guided by the belief that service to society is a meaningful expression of compassion, the Trust seeks to bring together faith, service and social responsibility.",
  "With a commitment to service since 1995, the Trust aims to develop meaningful initiatives and partnerships that contribute positively to society while respecting India's spiritual, cultural and humanitarian traditions.",
];

export const VISION =
  "To nurture a compassionate and inclusive society rooted in faith, service and human dignity, where religious and spiritual values inspire meaningful service to people, families, senior citizens, communities and society.";

export const MISSION =
  "To serve society through meaningful religious, spiritual and cultural activities connected with temples, while supporting education, children and senior citizens, including appropriate elder-care and old age home initiatives, health and family welfare, food and humanitarian assistance, community wellbeing and other socially beneficial initiatives. The Trust seeks to combine faith with service, compassion with responsibility, and tradition with meaningful community development.";

export const OBJECTIVES = [
  ["Religious & Spiritual Service", "Support and promote appropriate religious, spiritual and temple-related activities consistent with the Trust's objectives and values."],
  ["Cultural Heritage", "Encourage preservation and appreciation of cultural, spiritual and traditional values."],
  ["Education & Literacy", "Promote education, literacy and learning opportunities, particularly for children and underserved communities."],
  ["Child Welfare", "Support initiatives contributing to the wellbeing, development and educational opportunities of children."],
  ["Senior Citizen & Elder Care", "Support initiatives that promote dignity, care, safety, inclusion and wellbeing among senior citizens and vulnerable elderly members of society, including appropriate old age home, residential care and elder-support initiatives."],
  ["Old Age Homes", "Explore and support appropriate old age home and elder-care initiatives that provide dignity, safety, companionship, care and a supportive environment for senior citizens."],
  ["Health & Family Welfare", "Support appropriate health, wellbeing and family welfare initiatives."],
  ["Food & Humanitarian Support", "Facilitate appropriate food assistance and humanitarian support for vulnerable individuals and families."],
  ["Community Welfare", "Encourage initiatives that contribute to social wellbeing, inclusion and community development."],
  ["Collaboration & Service", "Work with individuals, institutions, organizations and well-wishers to support socially and spiritually beneficial initiatives."],
];

export const INTEREST_AREAS = [
  "Religious & Temple-Related Activities",
  "Spiritual & Cultural Initiatives",
  "Education & Literacy",
  "Children & Youth Welfare",
  "Senior Citizen Welfare",
  "Old Age Homes & Senior Citizen Care",
  "Health & Family Welfare",
  "Food & Humanitarian Support",
  "Community Welfare",
  "Volunteering",
  "Partnership / Collaboration",
  "Other",
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Our Activities", to: "/activities" },
  { label: "Our Initiatives", to: "/initiatives" },
  { label: "Elder Care", to: "/elder-care" },
  { label: "Projects", to: "/projects" },
  { label: "Gallery", to: "/gallery" },
  { label: "News & Events", to: "/news" },
  { label: "Contact", to: "/contact" },
];

// Simplified primary header navigation with a grouped "Our Activities" dropdown.
export const HEADER_NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  {
    label: "Our Activities",
    to: "/activities",
    children: [
      { label: "Our Initiatives", to: "/initiatives" },
      { label: "Elder Care", to: "/elder-care" },
      { label: "Projects", to: "/projects" },
      { label: "Gallery", to: "/gallery" },
      { label: "News & Events", to: "/news" },
    ],
  },
  { label: "Contact", to: "/contact" },
];
